import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  table: {
    padding: theme.spacing(0, 0, 4),
  },
  pagination: {
    padding: theme.spacing(1),
    overflow: 'visible',
    [theme.breakpoints.down('sm')]: {
      '& .MuiTablePagination-selectLabel': {
        display: 'none',
      },
      '& .MuiTablePagination-input': {
        display: 'none',
      },
      '& .MuiTablePagination-spacer': {
        display: 'none',
      },
      '& .MuiTablePagination-displayedRows': {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        '& ~ .MuiBox-root': {
          display: 'grid',
          gridTemplateColumns: 'repeat(5, 1fr)',
          width: '100%',
          '& .MuiButtonBase-root.MuiIconButton-root:nth-child(3)': {
            gridColumn: '4 / 5',
          },
        },
      },
    },
  },
  radiosContainer: { margin: theme.spacing(2, 0) },
  radioWrapper: {
    position: 'relative',
    display:'flex',
    paddingRight: theme.spacing(3),

    '&:hover': {
      backgroundColor: theme.palette.neutral.lightest,
      '& $iconButton': {
        display: 'grid',
        placeItems: 'center',
        pointerEvents: 'initial',
      },
    },
  },
  radio: {
    padding: theme.spacing(1),
    marginBottom: 0,

    '& .MuiRadio-root': {
      marginTop: -2.5,
    },
    '&:hover .MuiRadio-root': {
      color: theme.palette.primary.main,
    },
  },
  iconButton: {
    position: 'relative',
    top: '50%',
    right: 0,
    transform: 'translateY(-50%)',
    display: 'none',
    pointerEvents: 'none',
    width: 32,
    height: 32,
    marginRight: theme.spacing(1),
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  mainButton: {
    marginLeft: theme.spacing(2),
  },
  alert: {
    marginLeft: 'auto',
  },
  searchInput: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      paddingInline: theme.spacing(2),
    },
  },
  formErrors: {
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
  },
  emptyState: {
    marginTop: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: theme.spacing(3),
    padding: theme.spacing(10, 2),
    '&.big': {
      height: '75vh',
    },
  },
  buttons: {
    marginLeft:'auto',
    display:'flex',
    width:'auto'
  },
}))

export default useStyles
